package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Routing8Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/Routing8.md", mapOf())) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("dynamic-routes") }) {
                com.varabyte.kobweb.compose.dom.GenericTag("span", "data-id=\"title\"") {
                    org.jetbrains.compose.web.dom.Text("Dynamic routes")
                }
            }
            UrlBar("mysite.com/users/binay/post/108", Modifier.width(80.percent), id = "url")
            UrlBar("mysite.com/users/bitspittle/post/5", Modifier.width(80.percent).margin { top(1.cssRem) })
            UrlBar("mysite.com/users/cabs/post/9", Modifier.width(80.percent).margin { top(1.cssRem) })
            UrlBar("mysite.com/users/charlee/post/18", Modifier.width(80.percent).margin { top(1.cssRem) })
            UrlBar("mysite.com/users/opletter/post/32", Modifier.width(80.percent).margin { top(1.cssRem) })
            UrlBar("mysite.com/users/stevdza-san/post/182", Modifier.width(80.percent).margin { top(1.cssRem) })
            UrlBar("mysite.com/users/thedome/post/5", Modifier.width(80.percent).margin { top(1.cssRem) })
        }
    }
}
